<template>
    <div class="detailscenter">
        <div style="min-height: 100vh;" class="infinite-list">
            <a
            v-for="(item, index) in detailList"
            :key="index"
            :href="'/newsdetail?id='+item.id">
                <div class="main-item">
                <div class="main-left">
                    <img
                    :src="item.imgpath"
                    alt=""
                    />
                </div>
                <div class="main-right">
                    <div class="introduce-head">
                    <div class="introduce-left">
                        <strong><span class="title">{{item.title}}</span></strong>
                    </div>
                    <div class="introduce-right">
                        <el-icon><Timer /></el-icon>
                        <span class="time">{{ item.time }}</span>
                    </div>
                    </div>
                    <div class="content">
                    <div
                    class="typo content js-toc-content match-braces rainbow-braces"
                    id="content"
                    >{{divide(item.summary)}}</div>
                    </div>
                </div>
                </div>
            </a>
        </div>
        
        <!-- hide-on-single-page   当数据只有一页时,自动隐藏分页菜单 -->
        <!-- @size-change="handleSizeChange"   当每页显示的数据数目发生改变生的动作,需要按新的pageSize查询数据
        @current-change="handleCurrentChange"  当改变当前页时产生的动作
        :current-page="pageNo"                 绑定当前页
        :page-sizes="[5, 10, 30, 50]"          显示pageSize的选项
        :page-size="pageSize"				  绑定当前页数
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">				  绑定当前总数 -->
                   <el-pagination
                  class="pagination"
                  v-if="totalCount"
                  background
                  pager-count="3"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNo"
                  :page-sizes="[6, 12, 18, 30, 60]"
                  :page-size="pageSize"
                  layout="prev, pager, next"
                  :total="totalCount"
                  style="text-align: right; position: relative;left: -4%;"
                ></el-pagination>
        <!-- <detail :detailData="detailList" />
                      
        <pagination class="pagination" :dataSource="paginationData" /> -->
      </div>
  </template>
  <script>
  import { ElMessage } from "element-plus";
  
  export default {
    components: {},
    data() {
      return {
        pageNo:1,      // 默认当前是第一页
        pageSize:6,    // 当前每页的数据是5条
        totalCount:10,   // 总数默认为0
        detailList: [],
        alldetailList:[],
      };
    },
    methods: {    
        getnewlist(){
			    let config = {
                headers: { "Content-Type": "multipart/form-data" }
            };
            let param = new FormData(); //创建form对象
            this.$axios.post("http://82.157.23.29:5000/newsmanage", param, config)
            .then((response) =>{
                this.alldetailList=response.data;
                this.totalCount=this.alldetailList.length;
                this.pageNo=1;
                this.detailList=this.alldetailList.slice((0)*this.pageSize, 1*this.pageSize);
            });
        },
        handleSizeChange(val) { // 修改每页所存数据量的值所触发的函数
            this.pageSize = val;  // 修改页的大小
            this.detailList=this.alldetailList.slice((this.pageNo-1)*this.pageSize, this.pageNo*this.pageSize);
        },
        handleCurrentChange(val) { // 修改当前页所触发的函数
            this.pageNo = val;       // 更新当前的页
            this.detailList=this.alldetailList.slice((this.pageNo-1)*this.pageSize, this.pageNo*this.pageSize);
        },
        divide(input){
            return input.substr(0,105)+"..."
        },
  },
  created() {
    this.getnewlist();
  },
    computed: {},
  };
  </script>
  <style>
  .detailscenter {
    margin-left: 5vw;
  }
  .pagination {
    justify-content: center;
    align-items: center;
    margin-top: 5vh;
  }
  </style>
  <style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
  .main-item {
    box-sizing: border-box;
    height: 17vh;
    width: 90%;
    border-bottom: 1px solid #eee;
    padding: 3.5vh 0;
    display: flex;
    .main-left {
      margin-right: 2vw;
      width: 20%;
      flex: 0 0 14vh;
      height: 100%;
      overflow: hidden;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.7s ease-in-out;
      }
    }
         .main-right {
      flex: 1;
      overflow: hidden;
      .introduce-head {
        display: flex;
        justify-content: space-between;
        .introduce-left {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          .title {
            margin-right: 12px;
            font-size: 1.1vw;
            color: #000;
            line-height: 2.5vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            float: left;
          }
        }
        .introduce-right {
          white-space:nowrap;
          font-size: 0.8vw;
          color: #666;
          line-height: 1vw;
          .time {
            float: right;
          }
        }
      }
    }
     .content {
      margin-bottom: 12px;
      color: #999;
      font-size:0.9vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: left
    }
  }
}

  </style>
  